import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { Router } from '@angular/router';
import { LocalStorageService, SessionStorageService } from 'angular-web-storage';
import { Usuario } from 'app/oDres/modelos/Empresa/usuarios';
import { TemplateConfig } from 'app/oDres/modelos/Generales/templateConfig';
import { Notificacion } from 'app/oDres/modelos/Empresa/notificacion';
import { NotificacionService } from './notificaciones.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  public templateConf: TemplateConfig = null;
  templateConfSubject = new BehaviorSubject<TemplateConfig>(this.templateConf);
  templateConf$ = this.templateConfSubject.asObservable();
  usuario: Usuario = {} as Usuario;

  constructor(private authService: AuthService,
    private router: Router,
    public local: LocalStorageService,
    public session: SessionStorageService,
    private notificacionService: NotificacionService) {    

    this.templateConf = {
      layout: {
        variant: "Light",
        menuPosition: "Side",
        customizer: {
          hidden: true
        },
        navbar: {
          type: 'Static'
        },
        sidebar: {
          collapsed: true,
          size: "sidebar-md",
          backgroundColor: "man-of-steel",
          backgroundImage: true,
          backgroundImageURL: "https://grupoodresdiag.blob.core.windows.net/odes191231/010.jpg"
        }
      }
    };

    console.log('router constructor', this.router.url)
    console.log('usuarioConectado', this.authService.usuarioConectado)
    console.log('Usuario', this.authService.usuarioConectado.Usuario)

    if (this.authService.usuarioConectado?.Usuario == null ||
      this.authService.usuarioConectado?.Usuario == undefined ||
      this.authService.usuarioConectado?.Usuario.IdUsuario == null ||
      this.authService.usuarioConectado?.Usuario.IdUsuario == undefined) {

      //console.log('constructor config.service');        

      let IdEmpresa = sessionStorage.getItem('UsuarioCompletoIdEmpresa')
      console.log('sessionStorage', IdEmpresa)

      if (IdEmpresa == null || this.router.url == '/inicio/login') {        
        
        this.router.navigate(['/inicio/login']);

      } else {

        const usuarioStorage = this.local.get('UsuarioCompleto_' + IdEmpresa);

        console.log('Aqui llega para el usuarioStorage')

        if (usuarioStorage != null && usuarioStorage != undefined && usuarioStorage != '') {

          this.authService.usuarioConectado = JSON.parse(usuarioStorage);

          const listaUsuariosCompletos = this.local.get('listaUsuariosCompletos_' + IdEmpresa);

          this.authService.token = this.local.get('token_' + IdEmpresa)

          if (listaUsuariosCompletos != null && listaUsuariosCompletos != undefined && listaUsuariosCompletos != '') {

            this.authService.listaUsuarioCompleto = JSON.parse(listaUsuariosCompletos);

          }

          this.usuario.email = this.authService.usuarioConectado.Usuario.email;
          this.usuario.contrasena = this.authService.usuarioConectado.Usuario.contrasena;

          this.setConfigValue(100);

          this.notificacionService.obtenerNotificacionesCompletas({
            IdEmpresa: this.authService.usuarioConectado.Empresa.IdEmpresa,
            IdUsuarioDirigidoA: this.authService.usuarioConectado.Usuario.IdUsuario
          } as Notificacion).subscribe(respuestaNotificacion => {

            if (respuestaNotificacion != null && respuestaNotificacion.code == 200) {
              this.authService.usuarioConectado.ListaNotificaciones = respuestaNotificacion.model;
              const numeroAbiertas = this.authService.usuarioConectado.ListaNotificaciones.filter(n => n.Abierta == true).length;
              this.authService.usuarioConectado.NumeroNotificacionesSinVer = numeroAbiertas;
            }

          });

        } else {

          this.router.navigate(['/inicio/login']);

        }

      }

    } else {      

      this.setConfigValue(129);

    }

  }

  setConfigValue(line) {

    //console.log('router', this.router.url)
    //console.log('usuarioConectado', this.authService.usuarioConectado)
    //console.log('setConfigValue =>', this.authService.usuarioConectado);

    //console.log('line', line)

    if (this.authService.usuarioConectado.TemplateConf != null) {

      this.templateConf = this.authService.usuarioConectado.TemplateConf;

    } else {

      this.authService.usuarioConectado.TemplateConf = this.templateConf;

      this.authService.usuarioConectado.Configuracion = {
        idEmpresa: this.authService.usuarioConectado.Empresa.IdEmpresa,
        IdUsuario: this.authService.usuarioConectado.Usuario.IdUsuario,
        variant: this.templateConf.layout.variant,
        menuPosition: this.templateConf.layout.menuPosition,
        hidden: this.templateConf.layout.customizer.hidden,
        type: this.templateConf.layout.navbar.type,
        collapsed: this.templateConf.layout.sidebar.collapsed,
        size: this.templateConf.layout.sidebar.size,
        backgroundColor: this.templateConf.layout.sidebar.backgroundColor,
        backgroundImage: this.templateConf.layout.sidebar.backgroundImage,
        backgroundImageUrl: this.templateConf.layout.sidebar.backgroundImageURL,

      };
    }

    this.applyTemplateConfigChange(this.templateConf);

  }

  applyTemplateConfigChange(tempConfig: TemplateConfig) {
    this.templateConf = Object.assign(this.templateConf, tempConfig);
    this.templateConfSubject.next(this.templateConf);
  }

}
